import { dispatch } from '@src/dispatcher';

// Constants
import { ActionTypes } from 'constants/MogamboConstants';
import { PERMISSION_LEVELS } from '@src/const';

// API
import * as Api from '@src/api';

// Actions
import { userHasPermission, permissionErrorAlert } from './_utils';

export function updateCurrentLanguage(languageSource, languageScript) {
  dispatch(ActionTypes.UPDATE_CURRENT_LANGUAGE, {
    languageSource,
    languageScript,
  });
}

export async function addLanguageToBot(domain, languageList, callback) {
  if (!userHasPermission(PERMISSION_LEVELS.MOGAMBO_ALL_EDIT)) {
    return permissionErrorAlert();
  }

  const response = await Api.addLanguageToBot(domain, {
    language_list: languageList,
  });
  if (response.success) {
    const { body } = response;

    dispatch(ActionTypes.ADD_LANGUAGE_TO_BOT_SUCCESS, {
      supportedLanguages: body,
    });
  } else {
    dispatch(ActionTypes.ADD_LANGUAGE_TO_BOT_FAILED, {
      message:
        response.error || 'There was an error in updating the language list',
    });
  }

  if (callback) callback(response.success);
}
